// in src/students.js
import React, { useEffect,useState, Component } from 'react';
import { DateInput, FormDataConsumer, TopToolbar, useListContext, FunctionField, ArrayField, SingleFieldList, ChipField, List, Edit, Create, Datagrid, TextField, EditButton, LongTextInput, ReferenceInput, SelectInput, SimpleForm, TextInput, required, minLength, maxLength, minValue, maxValue, number, regex, email, choices, SelectField, AutocompleteInput } from 'react-admin';
import {BooleanField, BooleanInput, Filter, useInput, CreateButton, ShowButton, DeleteButton, BulkDeleteButton, Button } from 'react-admin';
import { Box, Typography, useMediaQuery, Dialog, DialogTitle, DialogContent, DialogActions, TextField as MuiTextField, FormControl, InputLabel, Select, MenuItem, FormControlLabel, Checkbox } from '@material-ui/core';
import MyTab from './mytab.js';
import { useDataProvider, useNotify } from 'react-admin';
import CreateToursEmailButton from './CreateToursEmailButton.js';
import {isAdmin} from './utils.js';
import {validateEnrollmentDate} from './utils.js';
import BlockTourButton from './BlockTourButton.js';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ScheduleIcon from '@material-ui/icons/Schedule';

const validateDate = [required(),regex(/[0-9][0-9][0-9][0-9]-[0-9][0-9]-[0-9][0-9]/, "Must be valid date yyyy-mm-dd")];
const validateTime = [required(),regex(/^(0?[1-9]|1[0-2]):[0-5][0-9]\s?(AM|PM)/,"Must be valid time hh:mm AM/PM")];

var d = new Date();
var dt = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-'
    + ('0' + d.getDate()).slice(-2);

const TourFilter = (props) => (
    <Filter {...props}>
        <TextInput alwaysOn label="Date" source="TourDate" ></TextInput>
        <SelectInput alwaysOn label="Status" source="Status" allowEmpty={false} choices={[
            // { id: 'All', name: 'All' },
            { id: 'Submitted', name: 'Submitted' },
            { id: 'Approved', name: 'Approved' },
            { id: 'Cancelled', name: 'Cancelled' },
            { id: 'NoShow', name: 'No Show' },
            { id: 'Completed', name: 'Completed' },
            { id: 'Available', name: 'Available' },
            { id: 'Blocked', name: 'Blocked' }
        ]} />
        {/* <ReferenceInput allowEmpty={false} alwaysOn label="Student Name" source="id" reference="Students" filter={{ FEStatus: "Active" }} sort={{ field: 'Sname', order: 'ASC' }}>
            <SelectInput optionText="Sname" />
        </ReferenceInput> */}
    </Filter>
);

function getChoices(record){
    // console.log("STATUS",record.Status)
    switch (record.Status) {
        case'Cancelled': {
            return [
                { id: 'Cancelled', name: 'Cancelled' },
            ];
        }
        case'Approved': {
            return [
                { id: 'Cancelled', name: 'Cancelled' },
                { id: 'Submitted', name: 'Submitted' },
                { id: 'NoShow', name: 'No Show' },
                { id: 'Completed', name: 'Completed' },
            ];
        }
        case'Submitted': {
            return [
                { id: 'Approved', name: 'Approved' },
                { id: 'Cancelled', name: 'Cancelled' },
            ];
        }
        case'NoShow': {
            return [
                { id: 'NoShow', name: 'NoShow' },
            ];
        }
        case'Completed': {
            return [
                { id: 'Completed', name: 'Completed' },
            ];
        }
    }

}
function getTourDates() {
    var d = new Date(),
        year = d.getYear(),
        weds = [];

    // d.setDate(1);

    // Get the first Wednesday in the month
    while (d.getDay() !== 3) {
        d.setDate(d.getDate() + 1);
    }

    // Get all the other Wednesday in the month
    while (d.getYear() === year) {
        var pushDate = new Date(d.getTime());
        // weds.push(pushDate.getDate() + '-' + (pushDate.getMonth() + 1) + '-' + pushDate.getFullYear());
        var dt = pushDate.getFullYear() + '-' + (pushDate.getMonth() + 1) + '-' + pushDate.getDate();
        weds.push({ id: dt, name: dt });
        d.setDate(d.getDate() + 7);
    }
    console.log("Weds ", weds);
    return weds;
}
const DynamicSelectInput = ({ ...props }) => {
    const choices = getTourDates();

    return <SelectInput {...props} choices={choices} />;
};


// const TourPNm = ({...props}) => {
//     const { filterValues } = useListContext();
//     if (filterValues.Status != 'Blocked' && filterValues.Status != 'Available') {
//         return (
//             <TextField label="Parent Name" source="ParentName" />
//         )
//     } else {
//         return (
//             null
//         )
//     }
// };
        
export const Tours = ({ permissions, ...props }) => {
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));   
    // console.log("perms ", permissions);
    if (permissions !== undefined && (permissions.role === 'admin' || permissions.role === 'officemgr')) {
        return (
            <List  {...props} filters={<TourFilter />} filterDefaultValues={{ TourDate: "", Status: "Submitted" }} bulkActionButtons={isAdmin(permissions)?<OfficeMgrListActions {...props} />:<UserListActions {...props} />} >
                {(
                    <Datagrid rowClick="edit" >
                         <TextField label="Date" source="Date" />
                         <TextField label="Time" source="Time" />
                         <TextField label="Status" source="Status" />
                         <TextField label="Parent Name" source="ParentName" />
                         <TextField label="Student Name" source="StudentName" />
                         <TextField label="Program Applying For" source="Program" />
                         <TextField label="Phone" source="Phone" />
                         <TextField label="Email" source="Email" />
                         <TextField label="Enrollment Date" source="EnrollmentDate" />
                         <BooleanField label="Reminder Sent" source="ReminderSent" />
                         <TextField label="Reason" source="ReasonForBlocking" /> 
                         <FunctionField
                            render={record => (
                                (record.Status != 'Blocked' && record.Status != '' && record.Status != 'Cancelled' && record.Status != 'Completed') ? <EditButton record={record} /> : null
                            )}
                        />
                         <FunctionField
                            render={record => (
                                (record.Status === 'Submitted' || record.Status === 'Approved') && (permissions.role === 'admin' || permissions.role === 'officemgr') ? <RescheduleTourButton record={record} /> : null
                            )}
                        />
                    </Datagrid>
                )}
            </List>
        );
    } else {
        return (<span>User has No Access...</span>)
    }
};


export const TourCreate = (props) => {
    const [customValue, setCustomValue] = useState('');

    const handleCustomChange = (event) => {
        setCustomValue(event.target.value);
    };


    const dataProvider = useDataProvider();
    const [TourDateTimes, setTourDateTimes] = useState([]);

    useEffect(() => {
        const fetchTourDateTimes = async () => {
            try {
                const fetchURL = process.env.REACT_APP_TOURDATES_URL
                const token = localStorage.getItem('token');
                const hdrs = new Headers({
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + token,
                })
                const params = new Object();
                const bdy = JSON.stringify(params);
                fetch(fetchURL, { method: 'GET', headers: hdrs })
                    .then(response => {
                        if (response.ok) {
                            response.json().then(json => {
                                if (json != "") {
                                    var dates = json.map((date, index) => {
                                        return {
                                            id: date, // Assuming you want 1-based indexing
                                            name: date
                                        };
                                    });
                                    dates.push({ id: 'custom', name: 'Enter custom value' }) // Option for custom value                                    )
                                    // console.log(dates);
                                    setTourDateTimes(dates)
                                } else {
                                    
                                }
                            });
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                        this.props.showNotification('Error: fetching TourDateTimes', 'warning')
                    });
  
            } catch (error) {
                console.error('Error fetching TourDateTimes:', error);
            }
        };

        fetchTourDateTimes();
    }, [dataProvider]);

    return (
        <Create {...props}>
            <SimpleForm>
                <Box p="1em">
                    <Box display="flex">
                        <Box >
                            <Typography variant="h6" gutterBottom>Tour Details</Typography>
                            <Box>
                                <Box display="flex">
                                    <TextInput label="Parent Name" source="ParentName" validate={required()}/>
                                </Box>
                                <Box>
                                    <TextInput label="Student Name" source="StudentName" validate={required()}/>
                                </Box>
                                <Box>
                                    <SelectInput style={{ width: "250px" }} alwaysOn label="Program Applying For" source="Program" allowEmpty={false} choices={[
                                        { id: 'Toddler', name: 'Toddler (18 - 36 months)' },
                                        { id: 'Primary', name: 'Primary (3 - 6 years)' },
                                    ]} validate={required()} />
                                </Box>
                                <Box>
                                    <DateInput label="Enrollment Date" source="EnrollmentDate" validate={validateEnrollmentDate} />
                                </Box>
                                <Box>
                                    <TextInput label="Email" source="Email" validate={required()}/>
                                </Box>
                                <Box>
                                    <TextInput label="Phone" source="Phone" validate={required()}/>
                                </Box>
                                <Box>
                                    {/* <DynamicSelectInput source="TourDateTimes" label="Date & Time" validate={required()} /> */}
                                    <SelectInput label="Available Dates & Time" source="DateTime" choices={TourDateTimes} optionText="name" optionValue="id" validate={required()} onChange={(event) => {
                    if (event.target.value !== 'custom') {
                        setCustomValue(''); // Clear custom input
                    } else {
                        setCustomValue('custom')
                    }
                }}/>
                {customValue === 'custom' && (
                <TextInput
                    source="Date"
                    label="Enter Date yyyy-mm-dd"
                    fullWidth
                    validate={validateDate}
                />
            )}
                {customValue === 'custom' && (
                    <TextInput
                        source="Time"
                        label="Enter Time hh:mm AM/PM"
                        fullWidth
                        validate={validateTime}
                    />
            )}
                                </Box>

                            </Box>
                        </Box>
                    </Box>
                </Box>
            </SimpleForm>
        </Create >
    );
};

const TourTitle = ({ record }) => {
    return <span>Tour {record ? `"${record.id}"` : ''}</span>;
};

export const TourEdit = (props) => (
    <Edit title={<TourTitle />} {...props}>
        <SimpleForm>
            <Box p="1em">
                <Box display="flex">
                    <Box >
                        <Typography variant="h6" gutterBottom>Tour Details</Typography>
                        <Box>
                            <Box display="flex">
                                <Box>
                                    <FormDataConsumer>
                                    {({formData, ...rest})  => {
                                return ( <SelectInput label="Status" source="Status" choices={getChoices(formData)} optionText="name" optionValue="id" validate={required()}/>
                                );
                            }}
                                    </FormDataConsumer>
                                    </Box>
                                    <Box ml="2em">
                                        <BooleanInput source="sendEmail" label="Send Email"  />
                                    </Box>
                            </Box>
                            <Box display="flex">
                                <TextInput disabled label="Parent Name" source="ParentName" validate={required()} />
                            </Box>
                            <Box>
                                <TextInput disabled label="Student Name" source="StudentName" validate={required()} />
                            </Box>
                            <Box>
                                    <SelectInput style={{ width: "250px" }} alwaysOn label="Program Applying For" source="Program" allowEmpty={false} choices={[
                                        { id: 'Toddler', name: 'Toddler (18 - 36 months)' },
                                        { id: 'Primary', name: 'Primary (3 - 6 years)' },
                                    ]} validate={required()} />
                                </Box>
                                <Box>
                                    <DateInput label="Enrollment Date" source="EnrollmentDate" validate={required()} />
                                </Box>
                            <Box>
                                <TextInput label="Email" source="Email" validate={required()} />
                            </Box>
                            <Box>
                                <TextInput label="Phone" source="Phone" validate={required()} />
                            </Box>
                            <Box>
                                <TextInput disabled label="Available Dates & Time" source="DateTime" validate={required()}/>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </SimpleForm>
    </Edit >
);

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const CustomBulkDeleteButton = (props) => (
    <BulkDeleteButton {...props} label={false} icon={<CheckCircleOutlineIcon style={{ color: "green" }} />} />
);

const UserListActions = (props) => {
    // console.log("In student buttons ", props);
    let st = props.filterValues.Status;
    // let cl = props.cl;
    // console.log("Classroom filter ", cl, st);
    return (
        <TopToolbar>
            {(st != undefined && st != "Available" && st != "Blocked") &&
            <><BulkDeleteButton {...props} undoable="true" /><MyTab /><MyTab /><MyTab /><MyTab /></>}
            {(st != undefined && st != "Available" && st != "Blocked") &&
            <CreateToursEmailButton {...props} />}
            {(st != undefined && st == "Available") &&
            <BlockTourButton {...props} />}
            {(st != undefined && st == "Blocked") &&
            <CustomBulkDeleteButton {...props} />}
        </TopToolbar>
    );
}

// Reschedule Tour Button Component
const RescheduleTourButton = ({ record, ...props }) => {
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const listContext = useListContext();
    const [open, setOpen] = useState(false);
    const [newDate, setNewDate] = useState('');
    const [newTime, setNewTime] = useState('');
    const [sendEmail, setSendEmail] = useState(true);
    const [selectedRecord, setSelectedRecord] = useState(null);

    const handleReschedule = async (event) => {
        // Prevent row click event from firing
        if (event) {
            event.stopPropagation();
        }
        
        if (!selectedRecord) {
            notify('No tour selected for rescheduling', 'error');
            return;
        }

        try {
            const response = await dataProvider.create('tours/TourDetails/reschedule', {
                data: {
                    originalTID: selectedRecord.TID || selectedRecord.id,
                    newDate: newDate,
                    newTime: newTime,
                    sendEmail: sendEmail
                }
            });
            
            notify('Tour rescheduled successfully', 'info');
            setOpen(false);
            // Refresh the list
            window.location.reload();
        } catch (error) {
            console.error('Reschedule error:', error);
            
            // Handle specific error cases
            if (error.status === 409) {
                notify('This tour slot is already booked. Please choose a different date and time.', 'error');
            } else if (error.status === 404) {
                notify('Original tour not found. Please refresh the page and try again.', 'error');
            } else if (error.status === 400) {
                notify('Invalid request. Please check your date and time selection.', 'error');
            } else if (error.status === 500) {
                notify('Server error occurred. Please try again later.', 'error');
            } else {
                notify('Failed to reschedule tour: ' + (error.message || 'Unknown error'), 'error');
            }
        }
    };

    const handleOpenDialog = (event) => {
        // Prevent row click event from firing
        if (event) {
            event.stopPropagation();
        }
        
        // Use the record prop directly if available (when used as a column)
        if (record) {
            console.log('Using record prop:', record);
            console.log('Record TID:', record.TID, 'Record ID:', record.id);
            setSelectedRecord(record);
            setOpen(true);
            return;
        }
        
        // Fallback to list context approach (for bulk actions)
        const selectedIds = listContext.selectedIds || [];
        if (selectedIds.length === 0) {
            notify('Please select a tour to reschedule', 'warning');
            return;
        }
        
        // Debug: Log the data structure
        console.log('ListContext data:', listContext.data, 'Type:', typeof listContext.data);
        console.log('Selected IDs:', selectedIds);
        console.log('ListContext keys:', Object.keys(listContext));
        
        // Check if data is available
        if (!listContext.data) {
            notify('Tour data is not available', 'error');
            return;
        }
        
        // Find the selected record in the data
        // Handle different data structures safely
        let recordToReschedule = null;
        let dataArray = null;
        
        if (Array.isArray(listContext.data)) {
            dataArray = listContext.data;
            console.log('Data is array, length:', dataArray.length);
        } else if (listContext.data && typeof listContext.data === 'object') {
            // Try common array properties
            dataArray = listContext.data.data || listContext.data.records || listContext.data.items;
            console.log('Data array from object:', dataArray);
        }
        
        if (dataArray && Array.isArray(dataArray)) {
            console.log('Searching in data array, length:', dataArray.length);
            console.log('First few items:', dataArray.slice(0, 3));
            
            // Try different ID matching strategies
            recordToReschedule = dataArray.find(item => {
                console.log('Checking item:', item.id, 'against selected:', selectedIds);
                return selectedIds.includes(item.id);
            });
            
            // If not found, try matching by TID field
            if (!recordToReschedule) {
                console.log('Trying TID matching...');
                recordToReschedule = dataArray.find(item => {
                    console.log('Checking TID:', item.TID, 'against selected:', selectedIds);
                    return selectedIds.includes(item.TID);
                });
            }
        }
        
        console.log('Found record:', recordToReschedule);
        
        if (!recordToReschedule) {
            // Fallback: Create a minimal record with just the ID
            console.log('Creating fallback record with ID:', selectedIds[0]);
            recordToReschedule = {
                id: selectedIds[0],
                TID: selectedIds[0],
                ParentName: 'Unknown',
                StudentName: 'Unknown'
            };
        }
        
        setSelectedRecord(recordToReschedule);
        setOpen(true);
    };

    const handleCloseDialog = (event) => {
        // Prevent row click event from firing
        if (event) {
            event.stopPropagation();
        }
        setOpen(false);
        setSelectedRecord(null);
        setNewDate('');
        setNewTime('');
        setSendEmail(true);
    };

    return (
        <>
            <Button
                label="Reschedule"
                onClick={handleOpenDialog}
                {...props}
            >
                <ScheduleIcon />
            </Button>
            
            <Dialog 
                open={open} 
                onClose={handleCloseDialog}
                disableBackdropClick={true}
                disableEscapeKeyDown={false}
                onClick={(e) => e.stopPropagation()}
            >
                <DialogTitle onClick={(e) => e.stopPropagation()}>
                    Reschedule Tour {selectedRecord ? `- ${selectedRecord.ParentName} (${selectedRecord.StudentName})` : ''}
                </DialogTitle>
                <DialogContent onClick={(e) => e.stopPropagation()}>
                    <MuiTextField
                        label="New Date (YYYY-MM-DD)"
                        type="date"
                        value={newDate}
                        onClick={(e) => e.stopPropagation()}
                        onChange={(e) => {
                            e.stopPropagation();
                            setNewDate(e.target.value);
                        }}
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                    />
                    <FormControl fullWidth margin="normal" onClick={(e) => e.stopPropagation()}>
                        <InputLabel>New Time</InputLabel>
                        <Select
                            value={newTime}
                            onClick={(e) => e.stopPropagation()}
                            onChange={(e) => {
                                e.stopPropagation();
                                setNewTime(e.target.value);
                            }}
                        >
                            <MenuItem value="09:00 AM">9:00 AM</MenuItem>
                            <MenuItem value="09:30 AM">9:30 AM</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControlLabel
                        onClick={(e) => e.stopPropagation()}
                        control={
                            <Checkbox
                                checked={sendEmail}
                                onClick={(e) => e.stopPropagation()}
                                onChange={(e) => {
                                    e.stopPropagation();
                                    setSendEmail(e.target.checked);
                                }}
                                color="primary"
                            />
                        }
                        label="Send Email Notification"
                    />
                </DialogContent>
                <DialogActions>
                    <Button label="Cancel" onClick={handleCloseDialog} />
                    <Button label="Reschedule" onClick={handleReschedule} />
                </DialogActions>
            </Dialog>
        </>
    );
};

const OfficeMgrListActions = (props) => {
    // console.log("In student buttons ", props);
    let st = props.filterValues.Status;
    // let cl = props.cl;
    // console.log("Classroom filter ", cl, st);
    return (
        <TopToolbar>
            {(st != undefined && st != "Available" && st != "Blocked") &&
            <CreateToursEmailButton {...props} />}
            {(st != undefined && st == "Available") &&
            <BlockTourButton {...props} />}
            {(st != undefined && st == "Blocked") &&
            <CustomBulkDeleteButton {...props} />}
        </TopToolbar>
    );
}
